@if(link()) {
<a
    class="button-undecorated header-button"
    [ariaLabel]="label()"
    [href]="link()"
    target="_blank"
    [ngClass]="{'active': isActive()}"
    (click)="modalService.closeModal()"
>
    <span
        class="label"
        [ngClass]="{'active': isActive()}"
    >
        {{label()}}
    </span>
    <div [ngClass]="{'underline': isActive()}"></div>
</a>
} @else {
<button
    class="button-undecorated header-button"
    [ariaLabel]="label()"
    [routerLink]="target()"
    [ngClass]="{'active': isActive()}"
    (click)="modalService.closeModal()"
>
    <span
        class="label"
        [ngClass]="{'active': isActive()}"
    >
        {{label()}}
    </span>
    <div [ngClass]="{'underline': isActive()}"></div>
</button>
}